export default {
  BASIC: 'Basic',
  MANAGER: 'Manager',
  ADMIN: 'Admin'
};
